import {
  cleanNonSessionProfileState,
  profileModifyState,
  setProfileLoyaltyState,
  setProfileContactState,
  setProfileAddressState,
  setProfileLicenseState,
  hydrateUIProfileModifyState,
  profileModify
} from './profile';
import { history } from './rewards';
import {
  communicationPreferencesState,
  communicationPreferences,
  hydrateUiProfileCommunicationPreferencesState,
  updateSubscriptions
} from './communicationPreferences';

// the following is imported in actions/index.js as "profile"
export default {
  cleanNonSessionProfileState,
  profileModify,
  history,
  hydrateUiProfileCommunicationPreferencesState,
  communicationPreferencesState,
  communicationPreferences,
  updateSubscriptions,
  /**
   * @namespace actions.profile.modify
   */
  profileModifyState,
  setProfileLoyaltyState,
  setProfileContactState,
  setProfileAddressState,
  setProfileLicenseState,
  hydrateUIProfileModifyState
};
